/* global __uspapi */
// ----------------------------------------------------- OPT-OUT //

// -------------------------- Set Cookie //
function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  const expires = `expires=${d.toUTCString()}`;
  document.cookie = `${cname}=${cvalue};${expires}; path=/ ;secure`;
}

// -------------------------- Get Cookie //
function getCookie(cname) {
  const name = `${cname}=`;
  const ca = document.cookie.split(';');

  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];

    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }

  return '';
}

// -------------------------- Check Cookie //
function checkCookie() {
  const optOutCookie = getCookie('opt_out');

  $('.opt-btn').remove();

  // Has Cookie //
  if (optOutCookie === '' || optOutCookie === 'in') {
    $('.opt-container').append('<button class="opt-btn btn-custom">Opt-Out <span class="glyphicon glyphicon-play"></span></button>');
    $('.opt-txt').text('in');

    return optOutCookie;
  }

  // Has No Cookie or Opted In //
  $('.opt-container').append('<button class="opt-btn btn btn-custom">Opt-in <span class="glyphicon glyphicon-play"></span></button>');
  $('.opt-txt').text('out');

  return optOutCookie;
}

checkCookie();

// -------------------------- Opt-Out Button //
$('body').on('click', '.opt-btn', e => {
  e.preventDefault();

  const optCookie = checkCookie();

  if (optCookie === '' || optCookie === 'in') {
    $('.screen, .opt-out-modal').show();
    setCookie('opt_out', 'out', 365);
  }
  else {
    $('.screen, .opt-out-modal').show();
    setCookie('opt_out', 'in', 365);
  }

  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });

  checkCookie();
});

// -------------------------- Opt-Out Button //
$('body').on('click', '.ddr-btn', e => {
  e.preventDefault();

  window.__uspapi('performDeletion', 1, null);

  $('.screen, .ddr-modal').show();

  window.scroll({
    top: 0,
    left: 0,
    behavior: 'smooth',
  });
});

// -------------------------- Close overlay //
$('body').on('click', '.screen', e => {
  e.preventDefault();
  $('.screen, .opt-out-modal, .ddr-modal').hide();
});
